module.exports = __webpack_public_path__ + "files/6e2a5594f957926a9640597ba05cfe36.png";